import React from "react";
import useFolderImages from "../hooks/useFolderImages";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { PAGE_TITLE_STYLE } from "../edit/textStyles";

function EventsPage() {
  const { images, loading, error } = useFolderImages("events_images");

  return (
    <div className="main-content" style={{ maxWidth: 1100, margin: "0 auto", padding: 24 }}>
      <EditableText id="events.title" defaultContent="活动剪影" defaultStyle={PAGE_TITLE_STYLE} />
      <h1 style={{ textAlign: "center", position: "absolute", left: "-9999px" }}>活动剪影</h1>
      {loading && <p style={{ textAlign: "center" }}>加载图片中…</p>}
      {error && <p style={{ textAlign: "center", color: "#c00" }}>{error}</p>}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 24,
          marginTop: 32,
        }}
      >
        {images.map((img) => (
          <div key={img.src} style={{ boxShadow: "0 2px 8px #0001", borderRadius: 8, overflow: "hidden", background: "#fff" }}>
            <img
              src={img.src}
              alt={img.alt}
              style={{ width: "100%", height: 220, objectFit: "cover", display: "block" }}
              loading="lazy"
            />
          </div>
        ))}
      </div>
      <PageCopyright pageId="events" />
    </div>
  );
}

export default EventsPage;
